import React, { useContext, useCallback } from 'react';
import { FormSpy } from 'react-final-form';
import InvestorDatagrid from './InvestorDatagrid';
import { CopyContactsContext } from './CopyContactsContext';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const InvestorsStep = props => {
  const { investorId, onSubmitEnd } = props;
  const { contactsContext, setContactsContext } = useContext(
    CopyContactsContext
  );

  const setInvestors = useCallback(
    values => {
      setContactsContext({
        ...contactsContext,
        currentForm: undefined,
        investors: values.investors
      });
      onSubmitEnd(values);
    },
    [contactsContext, onSubmitEnd, setContactsContext]
  );

  return (
    <CustomSimpleForm
      save={setInvestors}
      initialValues={{
        investors: contactsContext.investors || []
      }}
      toolbar={null}
      // We override the redux-form name to avoid collision with the react-admin main form
      resource="investors"
      variant="standard"
      margin="normal"
    >
      <FormSpy>
        {formprops => {
          if (contactsContext.currentForm === undefined) {
            setContactsContext({
              ...contactsContext,
              currentForm: formprops.form
            });
          }

          return (
            <InvestorDatagrid {...props} creation investorId={investorId} />
          );
        }}
      </FormSpy>
    </CustomSimpleForm>
  );
};

export default InvestorsStep;
